import { ForcedArray } from '../types';

/**
 * Wrap item in array if it's not an array already
 *
 * @param input
 * @returns {any[]}
 */

export default <InputType>(input: InputType) => {
    if (input === undefined || input === null) {
        return [] as ForcedArray<InputType>;
    } else if (Array.isArray(input)) {
        return input as ForcedArray<InputType>;
    }

    return [input] as ForcedArray<InputType>;
};
